const availabilityData = [
    { name: 'In Stock', slug: 'in-stock' },
    { name: 'Out Of Stock', slug: 'out-of-stock' },
    { name: 'Coming Soon!', slug: 'coming-soon' },
];

export default availabilityData;
